import { TeamComponent } from './components/team/team.component';
import { ProfileComponent } from './components/profile/profile.component';
import { BillingComponent } from './components/billing/billing.component';
import { PreferencesComponent } from './components/preferences/preferences.component';
import { CanDeactivateInformationPage } from '../information-page/can-deactivate.service';
import { BrandComponent } from './components/brand/brand.component';
import { TradeInfoComponent } from './components/trade-info/trade-info.component';
import { PermissionsGuard } from 'shared/permissions/permissions.guard';


export const accountInformationRoutes = [
  {
    path: '',
    component: ProfileComponent,
    canDeactivate: [CanDeactivateInformationPage],
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canDeactivate: [CanDeactivateInformationPage],
  },
  {
    path: 'team',
    component: TeamComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['catalog-view', 'catalog-edit', 'dam-view', 'dam-edit', 'fitments', 'admin'] },
    canDeactivate: [CanDeactivateInformationPage],
  },
  {
    path: 'preferences',
    component: PreferencesComponent,
    canDeactivate: [CanDeactivateInformationPage],
  },
  {
    path: 'billing',
    component: BillingComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['admin', 'repository'] },
    canDeactivate: [CanDeactivateInformationPage],
  },
  {
    // https://speedlab.atlassian.net/browse/SPD2-2856
    path: 'billing/:flow',
    component: BillingComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['admin', 'repository'] },
    canDeactivate: [CanDeactivateInformationPage],
  },
  {
    path: 'brand',
    component: BrandComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['admin'] },
    canDeactivate: [CanDeactivateInformationPage],
    showUpdatePublished: false,

  },
  {
    path: 'trade-info',
    component: TradeInfoComponent,
    canActivate: [PermissionsGuard],
    data: { permissions: ['admin'] },
    canDeactivate: [CanDeactivateInformationPage],
    showUpdatePublished: true,
  },
];
